<i18n>
de:
  unlocking: "\"{name}\" ermöglicht es Dir, die folgenden Artikel zu kaufen"

en:
  unlocking: "With \"{name}\", you will be able to purchase the following items"
</i18n>

<template>
  <div v-if="unlocks.length" class="pt-10 lg:pt-0">
    <h2 class="text-secondary-400 text-lg pb-4">
      {{ $t('unlocking', { name }) }}:
    </h2>
    <div class="unlockable-items">
      <ItemSwiper :items="unlocks" :slideCount="2" />
    </div>
  </div>
</template>

<script>
import ItemSwiper from '@/components/itemSwiper.vue'
export default {
  props: ['unlocks', 'name', 'sidebar'],
  components: { ItemSwiper }
}
</script>
